export default __webpack_public_path__ + "three-small-square-shapes.png";